import { render, staticRenderFns } from "./QuestionStart.vue?vue&type=template&id=68ad79f3&scoped=true&"
import script from "./QuestionStart.vue?vue&type=script&lang=ts&"
export * from "./QuestionStart.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionStart.vue?vue&type=style&index=0&id=68ad79f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad79f3",
  null
  
)

export default component.exports